const shorts = {
    "ChristmasLastYear":`If only we had mutual hobbies. Then I would have something to text her about.

    I tried coming up with something, anything, yet nothing at all came to my mind.
    
    Two whole days had passed since I had decided to text Shimamura. Between then and now, I had spent hours upon hours trying to come up with a topic that was both interesting and worthwhile—and most importantly, wouldn't make me look like a weirdo—for us to talk about, yet my efforts had borne no fruit. It was quite strange. Although I had not seen her for the entirety of winter break, I found myself unable to come up with a particular topic that I wanted to talk with her about.
    
    What did Shimamura enjoy? What were her hobbies? I buried my head into my pillow trying to figure out an answer. Of course, I wouldn't be having any of these issues if I knew that. Perhaps we could talk about New Year's? That had just passed by. Then again, I doubt that the conversation would go much beyond the amount of money we'd gotten from our parents. Speaking of my parents, I was starting to get worried that they would soon come knocking on my door if I spent any more time thinking about this. Sure, they mostly let me do my thing, but even they had their limits. With that in mind, I pulled out my phone and forced myself to type the following message.
    
    "Has anything interesting happened?"
    
    What a boring message, even for me. I was more or less kicking the ball into Shimamura's court, although at this point, what other option did I have? With the message now sent, I slowly placed the device onto my pillow before diving under the sheets, head and all. If a watched pot never boils, I could only imagine that the same was true for phones.
    
    This trick seemed to work, and soon enough, the device rang. I immediately leaped out from underneath the sheets, grabbed my phone, and opened the message.
    
    "Not really. Smiley face."
    
    That was it. What? "Smiley face"?
    
    Had she perhaps attempted to type an actual smiley face, but her phone's autocorrect had messed up, and she couldn't have been bothered to go back and fix it? Considering her personality, that most certainly seemed like a real possibility. It definitely fit my perception of her.
    
    "Huh... My perception of her..."
    
    While this message perfectly encapsulated Shimamura in my mind, I had to wonder, how did she see it? More precisely, what was her perception of me? And no, before you leap into conclusions, I didn't mean that in any sort of weird way.
    
    Wondering why I felt the need to be making these sorts of excuses, I went ahead and asked her.
    
    "Say, Shimamura. How do you see me?"
    
    I paused for a few moments before finally hitting the "send" button.
    
    I wonder, would I have done that to someone else? Or was it specifically because I was talking with Shimamura that I decided to think twice? Before I was able to find the answer to those questions, my phone rang once more. I grabbed the device and pulled it to me.
    
    A wave of anticipation and uncertainty ran through my mind as I opened the message.
    
    "🥺"
    
    "Huh? Wh-What?"
    
    An emoji? What was that supposed to mean? I quickly messaged her back for clarification.
    
    Like before, I didn't end up having to wait for long to receive my answer.
    
    "That's the face you make when you run away crying."
    
    "...What? N-No, I don't think so..."
    
    I shook my head at the screen repeatedly as if she could see it. Naturally, she didn't. What did happen, however, was that I received a new message.
    
    "Here's a better picture."
    
    This one came with an attachment. It was a drawing of a cartoon version of myself running away with tears flowing down her cheeks and her hands held high. And yes, she was making the face. All the while crying "Shimamuraaa!".
    
    The background was—for whatever reason—a grassy plain, with butterflies forming a circle around a giant whirlpool of a sun. In the middle of it all stood me. Wait... That part looked a lot different from the rest. Had she perhaps drawn this thing with her sister?
    
    I stared at the drawing hard. This was how Shimamura saw me. This was...
    
    "...Nobita Nobi?"
    
    Did she see me the same way Doraemon saw Nobita when the latter ran to him in tears? Surely not. No way. No. I once more pulled the sheets over my head in a desperate attempt to deny this conclusion.
    
    As my skin rubbed against the rough fabric, I could feel it growing slightly warm.
    
    The boomerang from earlier was still sitting on my shelf. I shoot a quick glance towards it before making Shimamura's drawing my phone's wallpaper. Was there anyone else in this whole world who could do that? Probably not, no. That thought passed my mind in the form of a gust of cool wind, perfectly refreshing my burning skin.
    `,
    
    "QuestionsAndAnswers1": `Q1 - What is the most important thing for a protagonist to possess?
    Shimamura: Sociability. Often, they're the head of the classroom.
    Adachi: A unique name, I guess.
    
    Q2 - What does one need to feel happy?
    S: A bed. A kotatsu is nice to have too, but having a bed is the most important.
    A: Shima-- Time to idle, or something.
    
    Q3 - Do you have a person in your life you always feel safe around?
    S: Hmm... My family, I guess?
    A: Shima-- Shimamura.
    
    Q4 - You are trapped in a room underground against your will. With you there are boys and girls of your own age. One day, one of your captors gives you a knife and says that if you kill one of the people trapped with you, they will let you go.
    Your options are a boy who you're good friends with, your beautiful mother, and a cute girl you've not seen before.
    Who do you kill to get out?
    S: Hmm... I'd probably let the other people decide. Yeah, I think I'd do that.
    A: My mother, probably.
    
    Q5 - A girl with hair that glows, a weirdo girl who wears a helmet and is a bit goofy, or a girl who's tall and slender.
    Which one of these do you choose?
    S: Well, I'm a girl myself, but I'd probably go with the tall one.
    A: None.
    
    Q6 - How much of a prince are you?
    S: Again, like I told you, I'm a girl.
    A: I'd rather be a princess, personally.
    
    Q7 - What do you think is the suitable maximum age difference between lovers?
    S: I haven't thought about that, but I think I'd be scared to go out with someone older than myself.
    A: I think it's best if there isn't any.
    
    Q8 - If you were to write a novel, what sort of novel would it be?
    S: The Mystery of a Doughnut That Vanished Yesterday.
    A: Shima-- It'd be about becoming friends.
    
    Q9 - You are a 24-year-old university student. You don't have any money. What do you do?
    S: Get a job.
    A: Get a job.
    
    Q10 - You find yourself having fallen in love with a certain girl. What do you do?
    S: Umm, why Adachi acting all weird?
    A: *Panicking*.
    
    Q11 - Someone comes in and steals your favourite food that you were saving to eat last. What do you do?
    S: Tell them that I would've given it to them if they'd asked, so next time, they should just ask.
    A: Start eating it first from then on.
    
    Q12 - If the world rewound every time you died, what would you do?
    S: Hmm... That's a tough one... Probably nothing special.
    A: Ask Shimamura for advice.
    
    Q13 - Describe your enthusiasm towards the next release in your series.
    S: Next up would be Valentine's Day, right? Hmm... That doesn't really have anything to do with me, I don't think.
    A: Ch-Chocolate?
    `,

    "NoesOfElephant":`"It's been ages since I last went to the aquarium, but that sure was a blast. Oh, how that place has changed over the years."

    "Huh."
    
    "If only it was closer by. I'd visit it all the time."
    
    "Hmm..."
    
    "Yes. So much fun."
    
    "Unlike talking with you."
    
    "Why do you say that?"
    
    "Because you never listen a single word I say."
    
    "Yeah I do. By the way, did you know that I can't swim?"
    
    "I'm pretty sure that we met by the pool."
    
    "Whatever. Anyway, I was thinking of visiting the zoo next."
    
    "Oh, sure."
    
    "You should come too!"
    
    "Huh?"
    
    
    
    "It'll be fun!"
    
    "Shut up."
    
    I wasn't sure why, but in the end, I'd allowed to woman to drag me with her. There was definitely some kind of magic to her irritating antics and borderline maddening way of talking. Load her up with merchandise or whatever and tell her to sell them, and I bet you could make a pretty buck.
    
    Not that it was any of my business, I thought to myself as I made my way over to her house. There by the car, a group of people stood waiting for me. There was her—obviously—her husband, their youngest daughter, and then... one more.
    
    She quickly noticed me, and immediately started doing her usual nonsense. As for her husband, he greeted me in a much more normal manner.
    
    "Good morning."
    
    "Good morning. Sorry... I don't mean to butt in on your family trip."
    
    "No, no. It's fine. The more the merrier."
    
    "Oh? Oh? Who's this? Obviously I know, but who's this?"
    
    We both ignored her.
    
    "But seriously though, don't worry about it. Besides, you're not the only guest we have."
    
    Her husband wrapped his hands around the girl and picked her up, almost like he was showing me the family cat or something. Coincidentally, the girl happened to be wearing an animal-themed onesie—or maybe a pyjama?—so I suppose it wasn't too far from what was happening. I continued to watch as her stubby limbs dangled in the air.
    
    It wasn't the first time I'd wondered about it, but who exactly was she? And why was her hair so... blue?
    
    "And what are you supposed to be today?"
    
    "A tiger."
    
    An attempt at a growl left her tiny mouth. That didn't sound like any tiger I'd ever heard.
    
    "You look more like a colourful cat to me."
    
    With that, her husband dropped the cat—ahem, tiger cub—only for their daughter to catch her from the air. They then began spinning around in circles while giggling. Truth be told, it seemed like they were having quite a bit of fun.
    
    "Children, right? Hahaha."
    
    The woman seemed quite proud of herself. Okay?
    
    "She's clearly not yours. Why is she always hanging around your house?"
    
    "Oh, yeah. She's an alien."
    
    Sounded like I'd just found the missing third child. Seriously? I glanced at her husband for an additional comment, but he only nodded his head.
    
    "So it would seem."
    
    It sounded like he could barely even remember.
    
    "...And what is an alien doing at your house?"
    
    "My daughter brought her in. My youngest daughter, I mean. She turned out to be quite the nice girl, so we let her stay."
    
    "That's not how that works. You should really... reconsider this whole thing."
    
    "No, no. It's fine. She follows me when I go shopping, and tells me all sorts of things about space. It's very interesting talking with her."
    
    There she went again, completely ignoring me. Aliens? Seriously? Then again, looking at the tiny creature frolicking before me, I couldn't deny that she had an... interplanetary feeling to her.
    
    "Pretty lucky that she happens to look like a human, right? Would be hard to communicate with her if she looked more like, say, a fish."
    
    "...Personally, I feel like you'd have no trouble communicating with a fish."
    
    It was painfully easy for me to imagine the scene of her excitedly listening to the life story of a fish swimming in a small water tank while repeatedly nodding her head.
    
    Now then, enough about that. We had a zoo to visit. Just how many years had it been since the previous time? I sure hope they'd gotten some funnier animals. Sensing that I was ready to go, the woman raised her hand and opened the rear seat door of the car.
    
    "I'm sitting in the back!"
    
    "Oh? I thought you would have taken the passenger seat."
    
    "Well, no. You don't want to mess with the driver. You might die."
    
    "Or you could just... not? Ever thought about that?"
    
    "That's boring."
    
    Declining to comment further, the woman stepped inside the vehicle. I guess that left the passenger seat for me. Honestly, I didn't mind. It was much better than having to sit next to her, that was for sure. When was the last time I'd sat in the passenger seat? When was the last time I'd been in a car? I was breaking a lot of streaks today, it seemed.
    
    With thoughts of all sorts flowing through my mind, I turned to face the windshield, and... nothing. No lingering bits of sentimentality, no anything.
    
    Behind me, the alien girl—or tiger cub, if you preferred that—had been placed in the middle seat, between the woman on one side and her daughter on the other. I managed to catch a glimpse of the daughter putting a small piece of candy in her mouth. "Just one, okay?" I believe was what she said. The girl's cheeks instantly grew puffy, to a point where yeah, it was pretty much impossible to see a tiger and not a cat.
    
    "Give me one too."
    
    "Just one, okay?"
    
    The woman ate the candy with similar delight.
    
    Looking at the two, I ended up meeting eyes with the tiger cub.
    
    "You are Adachi's mommy."
    
    "Umm, yeah?"
    
    Not only was the girl's hair blue, so were her eyes, sparkling like a pair of gemstones. Even her nails and teeth had a faint hue of blue to them.
    
    Honestly, I was starting to buy that whole alien thing. It was certainly more plausible than... whatever the alternative was.
    
    "She's a little... different, isn't she?"
    
    I hope you can forgive me for failing to find the right words here. It wasn't like I was expecting to be talking with an alien on my way to the zoo.
    
    "Me?"
    
    "Yeah? It's not like there are any other weirdos here."
    
    "Well, there is one..."
    
    "She's calling me a weirdo, dad."
    
    "My own daughter? A weirdo? I'm going to cry", replied the father.
    
    "That's so mean..."
    
    Waves of fake crying rolled over me from all directions.
    
    "What is this family...?"
    
    "Wahaha."
    
    "Hahaha."
    
    "Hehehe."
    
    Truth be told, the woman wasn't the only strange being around here. They all shared that title.
    
    
    The zoo we drove to was located outside of the city. It was absolutely massive, and even had a garden with all kinds of exotic plants.
    
    While nowhere near this grandiose, I too remembered once visiting a zoo on a family trip.
    
    As the smell of animals and vegetation filled the vehicle, it brought those memories back into my mind.
    
    Back then, my husband had still been living with me. And my daughter.
    
    These days, it was just me in that house. Not that I minded. If anything, I felt like living by myself suited my personality better. I'd gone through all that, built myself a family, and then, at the flip of a switch, I'd lost it all. Did I have any regrets? No, not really.
    
    That would have required a certain amount of happy memories---memories which I lacked.
    
    We began walking around the zoo together. Whether it was real or just my mind playing tricks on me, that I didn't know, but I found the variety of animals here to be much more diverse than it had been at that other zoo all those years ago. They had tanukis, serows, pelicans... Honestly, how did they even take care of them all? It must have been a nightmare to work here. Myself, I'd barely been able to raise my own daughter.
    
    We eventually made our way over to the lion enclosure. I watched as the creature majestically swallowed a slice of raw meat, before turning around to our own tiger cub, currently in the process of sucking on a piece of candy. I wonder, how did this mysterious alien appear to the animals? Also, which one would win in a fight: An alien or a lion? I know, I know. I was too old to be thinking about stuff like that.
    
    Next up, we arrived at the aviary. Yelling louder than any bird could, the woman immediately ran inside with the kids. Really not feeling like following her, I decided to sit this one out.
    
    As I was waiting, I found my throat starting to grow dry. I immediately began looking around for a vending machine or something, only for the woman's husband to appear from around the corner. He gave me a small nod, to which I nodded back before grabbing the bottle of green tea he was offering me.
    
    "Sorry about that. She just gets so excited when she sees animals."
    
    "Some of us never quite grow up, huh?" I stated as a joke, to which the man laughed.
    
    "You can say that again. She's a restless one, that's for sure. Always has to be doing something. It was like that when we first met, too. I figured that she'd grow out of it eventually, but if anything, it has only gotten worse."
    
    It was quite the way for a husband to be talking about his wife. Then again, as someone who'd had the misfortune of knowing her for over a decade now, I definitely saw where he was coming from. The woman had mastered the art of being annoying, always pulling out just as her victim was starting to lose their temper.
    
    "She has made herself quite a lot of friends with her attitude, but also a non-insignificant amount of enemies. And yet, no matter how many times it backfires, she just keeps going for it. Personally, I think that's quite admirable."
    
    "Huh... Maybe."
    
    Being able to act so friendly with people you'd never met before had to be some kid of a gift, no two ways about it.
    
    Myself, I'd yet to decide whether I liked it or not.
    
    It didn't take too long for the woman, her daughter, and the alien to return from the aviary. The three of them all had wide grins on their faces, signalling that they had quite enjoyed the experience. The man left my side to go look after the children, and as if taking his place, the woman in turn walked over to me.
    
    "What were you two talking about?"
    
    "You."
    
    "Really? You're making me blush."
    
    I glanced in the direction of the woman's husband, only to find him lifting the blue-haired girl in the air and asking his daughter if they "looked like a giraffe". What? Actually, never mind. I didn't want to know.
    
    "He's such an airhead, that man. My oldest takes after him quite nicely."
    
    "Your oldest? Oh, yeah..."
    
    She meant the one who lived with my daughter---the one she wanted to spend her life with.
    
    "So, how about you? Having fun?"
    
    "It's alright."
    
    "Here, let me pick you up!"
    
    The woman extended her arms as if she was serious. I slapped her on the head and sighed.
    
    "I'm reminded of the time I last visited a zoo. It was decades ago at this point."
    
    "Was your daughter with you?"
    
    "Yes, and my husband too. Hmm... I think there was this plushy or something that she wanted. I don't know why, but she never asked me to buy it for her. I kinda wish I had, though. I feel like things might have played out differently..."
    
    Perhaps I should have just taken the initiative. Perhaps I should have shown my affection. Personally, I always disliked when people did that, and so, instinctively, I had assumed that she did as well. And yet, I'd been wrong; though a mother and a daughter, we were hardly the same person.
    
    For whatever reason, the woman decided that the following reaction was appropriate:
    
    "Well, in that case, how about you buy a plushy now and give it to her?"
    
    "...She's an adult. Not a kid."
    
    "And? Is it any different if you do it now?"
    
    God, how annoying could a person possibly be?
    
    "Myself, I loved getting gifts when I was little, and I still love getting them now! Give me something!"
    
    "Shut up."
    
    "Be it a giraffe, or an elephant, I love them all!"
    
    "What am I going to do with you...?"
    
    "Tigers though, those are a little bit too scary for me. Nothing at all like our adorable little tiger. No, they have the eyes of a killer."
    
    "...Well, yeah. That's what tigers do. They kill."
    
    This conversation was going nowhere. I found myself growing more annoyed by the second. It didn't certainly help that the woman was practically yelling.
    
    There was not a single part to her that I thought I would have gotten along with. And yet, put them together, and somehow, the combination was able to tug on my heartstrings.
    
    Brighter than even the sun, her genuine honesty shone through my cold exterior. It was as if I was being born anew.
    
    So, that happened.
    
    We passed through the gift shop on our way back. Recalling the teary face of my daughter from all those years back, I ended up purchasing an elephant plushy.
    
    I held it up, and behind its head, I saw Yoshika duking it out with a giant bear.
    `


}

export function getShorts() {
    return shorts
}